import React, { useEffect, useState } from "react";
import "./GoLive.css";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import { live_grp_one } from "../../../assets";
import { addLiveEventApi, updateLiveEventApi } from "../../../services/goLive";
import { allowAlphabetsWithSpace } from "../../../utils/inputValueValidation";
import { toastMessage } from "../../../utils/toastMessage";
import { useNavigate, useParams } from "react-router";
import { DatePicker, LoadingButton } from "../../../Components/header/form";
import {
  addMinutesToISODate,
  isoTimeFormat,
} from "../../../utils/dateTimeFormat";
import { Link, useSearchParams } from "react-router-dom";
import { decryptData } from "../../../utils/dataCipher";
import moment, { duration } from "moment";
import { FaArrowLeft } from "react-icons/fa";

const GoLive = () => {
  const [inputData, setInputData] = useState({});
  const [inputDate, setInputDate] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParam, setSearchParam] = useSearchParams();

  let groupDetail = searchParam.get("info") || "";

  let encryptedData;

  // Get the query string (encrypted data)
  if (groupDetail) {
    encryptedData = decryptData(groupDetail);
  }

  const createEventHandler = async () => {
    try {
      setLoading(true);

      const payload = {
        title: inputData?.title || "",
        startDateTime: inputDate ? isoTimeFormat(inputDate) : "",
        endDateTime: inputDate
          ? addMinutesToISODate(
            isoTimeFormat(inputDate),
            inputData?.duration || 0
          )
          : "",
      };

      if (encryptedData?.live?._id) {
        Object.assign(payload, { _id: encryptedData.live._id });
      } else {
        Object.assign(payload, { _group: encryptedData?._id });
      }

      const isUpdate = Boolean(Object.keys(encryptedData?.live || {}).length);
      const apiCall = isUpdate ? updateLiveEventApi : addLiveEventApi;

      const { data } = await apiCall(payload);

      if (data?.success) {
        navigate("/dashboard/overview/live-details");
        toastMessage(data.message, "success", "addGroupHandler");
      } else {
        toastMessage(
          data?.message || "An error occurred",
          "error",
          "addGroupHandler"
        );
      }
    } catch (error) {
      console.error("Error:", error.message);
      toastMessage(
        error?.message || "Something went wrong",
        "error",
        "addGroupHandler"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (encryptedData?.live?._id) {
      setInputData({
        title: encryptedData?.live?.title || "",
        duration:
          encryptedData?.live?.endDateTime && encryptedData?.live?.startDateTime
            ? moment(encryptedData?.live?.endDateTime).diff(
              moment(encryptedData?.live?.startDateTime),
              "minutes"
            )
            : "",
      });
      setInputDate(new Date(encryptedData?.live?.startDateTime) || "");
    }
  }, [encryptedData?._id]);

  // console.log(encryptedData, "encryptedData");

  return (
    <>
      <DashboardHeader title={"Groups"} />

      <div className="golive_parent">
        <div className="golive_wrap">
          <ul className="_breadcrumb">
            <li className="__breadcrumb_group">
              <Link to={-1}><FaArrowLeft/></Link>
            </li>
            <li>
              <span>All Live Groups</span>
            </li>
          </ul>

          <div className="golive_content">
            <img src={encryptedData?.coverImage || live_grp_one} alt="img" />

            <div className="golive_txt">
              <p className="title">{encryptedData?.categoryName || "---"}</p>
              <b className="heading">{encryptedData?.name || "---"}</b>
              <p className="txt">{encryptedData?.description || "----"}</p>
            </div>
          </div>

          {/* form */}

          <div className="golive_form">
            <form className="form-group">
              <div className="input-wrapper">
                <label className="label">Title</label>
                <input
                  type="text"
                  className="input-field"
                  placeholder="Enter Title"
                  name="title"
                  value={inputData?.title || ""}
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      title: allowAlphabetsWithSpace(e.target.value),
                    })
                  }
                />
              </div>

              <div className="input-wrapper">
                {/* <label className="label">Date & Time</label>
                <div className="date-input-wrapper"> */}
                <DatePicker
                  required
                  className="input form-control"
                  label="Date & Time"
                  value={inputDate || ""}
                  onChange={(date) => setInputDate(date)}
                  placeholder="Select Date & Time"
                  showTimeSelect
                  minDate={Date.now()}
                  timeIntervals={15}
                  dateFormat="MMMM d, yyyy h:mm aa"
                />
                {/* </div> */}
              </div>

              <div className="input-wrapper">
                <div className="select-wrapper">
                  <label className="label">Select duration</label>
                  <select
                    className="input-field"
                    onChange={(e) =>
                      setInputData({ ...inputData, duration: e.target.value })
                    }
                    value={inputData?.duration}
                  >
                    <option value="" disabled selected>
                      Select Time Duration
                    </option>
                    <option value="15">15 minutes</option>
                    <option value="30">30 minutes</option>
                    <option value="45">45 minutes</option>
                    <option value="60">1 hour</option>
                  </select>
                </div>
              </div>
            </form>
            <LoadingButton
              onClick={createEventHandler}
              className="create_btn"
              type="button"
              loading={loading}
            >
              Create
            </LoadingButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoLive;
